import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from './components/spinners/loader/loader.component';
import { MatProgressSpinnerModule } from '@angular/material';
@NgModule({
  imports: [
    MatProgressSpinnerModule,
    CommonModule
  ],
  declarations: [LoaderComponent],
  entryComponents: [LoaderComponent],
  exports: [LoaderComponent]
})
export class CommonloaderModule { }
